import { FormSetting } from '@/form-settings/form-setting';

export class AccessoryPracticeFormSetting extends FormSetting {
  protected static classToCall: string;

  public static setClassToCall(classes) {
    this.classToCall = classes;

    return this;
  }

  public static getMeta(): Array<any> {
    return [
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'descrizione',
            label: 'Descrizione',
            controlType: 'autocomplete-string',
            class: 'lg:w-12/12 w-full',
            order: 1,
            required: true,
            options: this.data['accessories'] ?? [],
            customAction: 'updateAccessoryFields',
          },
          {
            classToUse: this.classToCall,
            key: 'prezzo',
            label: 'Prezzo',
            controlType: 'number',
            class: 'lg:w-12/12 w-full',
            order: 1,
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'provvigione',
            label: 'Provvigione',
            controlType: 'number',
            class: 'lg:w-12/12 w-full',
            order: 1,
            disabled: true,
          },
        ],
        order: 1,
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'id',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
          {
            classToUse: this.classToCall,
            key: 'creator',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
          {
            classToUse: this.classToCall,
            key: 'pratica',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
        ],
        order: 1,
      },
    ];
  }
}
